
window.SETTINGS = {
  // How many different dispatched actions determine loading progress
  // This is likely determined by how many dispatched actions you have below
  // in the created() method
  LOADING_SEGMENTS: 2,
  API_BASE_PATH: '/wp-json/wp/v2/'
}

require('./bootstrap')

import 'babel-polyfill'
import Vue from 'vue'
import vSelect from 'vue-select'
import VueRouter from 'vue-router'
import VueLazyload from 'vue-lazyload'
import VueTheMask from 'vue-the-mask'


import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css';

import router from './router'
import App from './App.vue'
import store from './store'
import * as types from './store/mutation-types'
import * as VueGoogleMaps from "vue2-google-maps"
import Slick from 'vue-slick'
import mixin from "./mixin";

Vue.mixin(mixin);

Vue.use(VueLazyload)
Vue.use(BootstrapVue)
Vue.use(VueTheMask)

Vue.component('slick', Slick)
Vue.component('v-select', vSelect)
Vue.component('blog-item', require('./components/widgets/blog-item.vue'))

var VueScrollTo = require('vue-scrollto');

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCT0s3drh2lkjhrKnbqPNKd5XaHCKoYO8o",
    libraries: "places" // necessary for places input
  }
});

router.afterEach((to, from) => {
  // Add a body class specific to the route we're viewing
  $("body").removeClass (function (index, className) {
    return (className.match (/(^|\s)vue--page--\S+/g) || []).join(' ');
  });
  $("body").addClass("vue--page--"+_.toLower(to.name))
})

Vue.config.ignoredElements = ['gcse:search', 'gcse:searchbox', 'gcse:searchresults']

export const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  created () {
    this.$store.commit(types.RESET_LOADING_PROGRESS)
    this.$store.dispatch('getAllCategories')
    this.$store.dispatch('getAllPages')

    this.load()
    // this.loadCurso()
    // Once user is signed in/out, uncomment if you need Firebase authentication
    // auth.onAuthStateChanged(user => {
    //   if (user) {
    //     this.$store.commit(types.LOGIN_USER)
    //     this.$store.commit(types.STORE_FETCHED_USER, user)
    //   } else {
    //     this.$store.commit(types.LOGOUT_USER)
    //   }
    // })
  },

  methods:{
    async load(){
      var url = 'http://manager.escolabauhaus.com.br/api-bhs/cursos/'

      url += moment().get('year')
      url += "bau"
      url += moment().get('month') + 1
      url += "haus"
      url += moment().get('date')
      url += ""

      var url2 = 'http://manager.escolabauhaus.com.br/api-bhs/assuntos-cursos/'

      url2 += moment().get('year')
      url2 += "bau"
      url2 += moment().get('month') + 1
      url2 += "haus"
      url2 += moment().get('date')
      url2 += ""

      var response = await axios.get(url)
      var response2 = await axios.get(url2)

      this.$store.commit('setCursosApi', response.data)
      this.$store.commit('setAssuntosApi', response2.data)

    }
  },

  
})



// WEBPACK FOOTER //
// ./src/app.js